<template>
  <div class="activityInformation common_group">
    <div class="title">
      <img src="@/assets/images/activityIcon.png">
      <span>活动信息</span>
    </div>
    <el-form class="common_form" label-position="left" ref="activityDataForm" :rules="rules" label-width="140px" :model="activityData">
      <el-row>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="活动编号">
            <div class="text">{{ activityData.activityCode }}</div>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="活动名称">
            <div class="text" :title="activityData.activityName">{{ activityData.activityName }}</div>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="活动分类">
            <div class="text">{{ activityData.activityClassification }}</div>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="活动形式">
            <div class="text">{{ activityData.activityForms }}</div>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="活动类型">
            <div class="text">{{ activityData.activityType }}</div>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="细分活动类型">
            <div class="text">{{ activityData.activitySubtype }}</div>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="模板活动名称">
            <div class="text" :title="activityData.relatedActivityName">{{ activityData.relatedActivityName }}</div>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="活动对应销售">
            <div class="text">{{ activityData.salerName }}</div>
          </el-form-item>
        </el-col>
        <!--        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">-->
        <!--          <el-form-item label="活动对应品推">-->
        <!--            <div>{{ activityData.activityCode }}</div>-->
        <!--          </el-form-item>-->
        <!--        </el-col>-->
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    detailsData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      rules: {},
      activityData: {}
    };
  },
  mounted () {
    this.activityData = this.detailsData.marketActivity;
  }
};
</script>

<style lang="scss" scoped>
</style>
